import React from "react";
import { Navigation } from "./navigation";
import { Contact } from "./contact";

export default function SeoLandingPage({ title, subtitle, intro, sections, ctaText }) {
  return (
    <>
      <Navigation />

      <article className="cc-blog-shell">
        <header className="cc-blog-hero">
          <p className="cc-blog-kicker">Crew Coin Guide</p>
          <h1>{title}</h1>
          <p className="cc-blog-intro">{intro}</p>
          <p className="cc-blog-subtitle">{subtitle}</p>
          <a className="cc-blog-cta-dark" href="#contact">{ctaText}</a>
        </header>

        <main className="cc-blog-content">
          {sections.map((section, idx) => (
            <section key={idx} className="cc-blog-section">
              <h2>{section.heading}</h2>
              <p>{section.body}</p>
            </section>
          ))}
        </main>

        <section className="cc-blog-bottom-cta">
          <h3>Ready to launch Crew Coin with your team?</h3>
          <p>Set up your account, create your first incentives, and start reinforcing great performance today.</p>
          <a href="/#/signup" className="btn btn-custom2 cc-signup-btn">Get Started</a>
        </section>
      </article>

      <div className="cc-contact-spacer">
        <Contact data={{}} />
      </div>
    </>
  );
}
